export {
  createHeadersMarkdownPlugin,
  createHeadersMarkdownDecorator,
} from './createHeadersMarkdownPlugin';
export const HEADERS_MARKDOWN_TYPE = 'wix-draft-plugin-headers-markdown';
export { pluginHeadersMarkdown } from './editor';
